import React from "react";
import { printElement } from "../../master/Print";
import useAppConfig from "../../config/useAppConfig";
import StudentAdmissionFrom2 from "../components/StudentAdmissionFrom2";
import StudentAdmissionFrom1 from "../components/StudentAdmissionFrom1";
import StudentAdmissionFrom3 from "../components/StudentAdmissionFrom3";
import usePrivateLink from "../../config/usePrivateLink";

export default function StudentAdmissionForm({ data }) {
  const config = useAppConfig("Student", "admission_form");
    const hasAccess = usePrivateLink();
  
  return (
    <div className="card">
      <div className="card-body overflow-auto">
        <div className="row">
          <div className="col-12 text-end mb-1">
            {hasAccess("/admission/form/print") &&
              <button
                className="btn btn-info"
                onClick={() => printElement("PrintDiv")}
              >
                <i className="ri-printer-line"></i>
              </button>
            }

          </div>
          <div className="col-12">
            {config?.value === "admission_form_1" ? (
              <StudentAdmissionFrom1 data={data} />
            ) : config?.value === "admission_form_2" ? (
              <StudentAdmissionFrom2 data={data} />
            ) : config?.value === "admission_form_3" ? (
              <StudentAdmissionFrom3 data={data} />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
